import moment from "moment-timezone";
import ParseQueryString from "../utils/ParseQueryString";

export default abstract class EventStatus {
  currentDateTime: moment = null;
  validModels: string[] = [
    "impreza",
    "liberty",
    "brz",
    "wrx",
    "wrx sti",
    "wrx or wrx sti",
    "xv",
    "forester",
    "outback",
    "levorg"
  ];

  constructor() {
    const query: any = ParseQueryString();

    if (typeof query.promoTime !== "undefined") {
      const customTime = moment.tz(query.promoTime.replace("%20", " "), "Australia/Melbourne");
      if (customTime.isValid()) {
        this.currentDateTime = customTime;
        console.log(`Using Faux Melbourne Time: ${this.currentDateTime.format()}`);
      } else {
        console.log('Faux date format not ok. Must be "2017-11-09 14:00:00".');
      }
    }

    if (!this.currentDateTime) {
      this.currentDateTime = moment().tz("Australia/Melbourne");
    }

    const comment = document.createComment(`Promo:${this.currentDateTime.format()}`);
    document.body.appendChild(comment);
  }

  public appliesToModel(modelName: string): boolean {
    const modelsPassed = this.validModels.filter(model => modelName.toLowerCase() === model.toLowerCase());
    return !!modelsPassed.length;
  }
}
